// import styles from "./Switch.module.css";

// interface SwitchProps {
//     isChecked: boolean;
//     toggleSwitch: (event?: React.ChangeEvent<HTMLInputElement>) => void;
//     name?: string;
//     disabled?: boolean;
//     ref?: React.Ref<HTMLLabelElement>

// }

// export const Switch = ({ isChecked, toggleSwitch, name, disabled, ref }: SwitchProps) => {

//     return (
//         <label ref={ref} className={`${styles.switch}`}>
//             <input name={name} type="checkbox" checked={isChecked} onChange={(event) => toggleSwitch(event)} disabled={disabled} />
//             <span className={`${styles.slider} round`}></span>
//         </label>
//     )
// }

import React, { forwardRef } from "react";
import styles from "./Switch.module.css";

interface SwitchProps {
    isChecked: boolean;
    toggleSwitch: (event?: React.ChangeEvent<HTMLInputElement>) => void;
    name?: string;
    disabled?: boolean;
}

// Use forwardRef to pass the ref properly
export const Switch = forwardRef<HTMLLabelElement, SwitchProps>(
    ({ isChecked, toggleSwitch, name, disabled }, ref) => {
        return (
            <label ref={ref} className={`${styles.switch}`}>
                <input
                    name={name}
                    type="checkbox"
                    checked={isChecked}
                    onChange={toggleSwitch}
                    disabled={disabled}
                />
                <span className={`${styles.slider} round`}></span>
            </label>
        );
    }
);

// Set display name for debugging purposes
Switch.displayName = "Switch";
